<a-context-container>
  <div a-popup (close)="onCancelContextPopup()" [title]="title" [class]="className" [setFocus]="setFocus">
    <ng-content></ng-content>
  </div>
</a-context-container>
